module.exports = __webpack_public_path__ + "img/menu4-4.1b6e284c.svg";